export const MAX_SCREEN_WIDTH = '1290px';
export const MIN_SCREEN_WIDTH = '850px';
export const SCROLLED_TOP = 200;
export const SCROLLED_CONTAINER = 'mat-sidenav-content';
